/**
 * Intrinsic width/height hint for `images/web/loading-dots.gif` in compact UI (buttons, inline loaders).
 * Scaled from the asset's 150×343 so the aspect ratio matches; CSS (e.g. max-height) still controls painted size.
 *
 * Full-page / hero loaders in ERB and explore search often keep width={150} height={343} so the reserved
 * box matches the file until styles constrain — same ratio, different layout budget.
 */
export const LOADING_DOTS_COMPACT_INTRINSIC = { width: 24, height: 55 } as const
